import request from './request';
import trim from './trimHelper';

const X_CALLER_ID = 'gia-appeal::service';

export function fetchGET(url) {
  const options = {
    headers: {
      'x-caller-id': X_CALLER_ID,
    },
    method: 'GET',
    credentials: 'include',
  };

  return request(url, options);
}

export function fetchPOST(url, body) {
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-caller-id': 'gia-appeal::service',
    },
    credentials: 'include',
    method: 'POST',
    body: JSON.stringify(body),
  };

  return request(url, options);
}

export function fetchDELETE(url, params) {
  const options = {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'x-caller-id': X_CALLER_ID,
    },
  };

  let urlWithParams = url;
  if (params) {
    const trimmedParams = trim(params);

    const queryString = Object.keys(trimmedParams)
      .map((k) => `${k}=${trimmedParams[k]}`)
      .join('&');

    urlWithParams = `${url}?${queryString}`;
  }

  return request(urlWithParams, options);
}
